import { applyMaskAlpha } from './maskOps.js';
/** Produces the final RGBA buffer to encode, applying the mask and (for JPEG) flattening onto a fill color. */
export function composeExportBuffer(rgba, mask, options) {
    const masked = applyMaskAlpha(rgba, mask);
    const needsFill = options.format === 'jpeg' || options.fillColor !== undefined;
    if (!needsFill)
        return masked;
    const fill = options.fillColor ?? { r: 255, g: 255, b: 255 };
    const out = new Uint8ClampedArray(masked.length);
    const pixelCount = mask.width * mask.height;
    for (let i = 0; i < pixelCount; i++) {
        const o = i * 4;
        const a = masked[o + 3] / 255;
        out[o] = Math.round(masked[o] * a + fill.r * (1 - a));
        out[o + 1] = Math.round(masked[o + 1] * a + fill.g * (1 - a));
        out[o + 2] = Math.round(masked[o + 2] * a + fill.b * (1 - a));
        out[o + 3] = options.format === 'jpeg' ? 255 : masked[o + 3];
    }
    return out;
}
//# sourceMappingURL=export.js.map